import { createContext } from "react";
import { EventParticipantFragment } from "../../../__generated__/graphql";

export interface EventDetailsContextType {
  selectedParticipants: EventParticipantFragment[];
  toggleParticipant: (participant: EventParticipantFragment) => void;
  clearSelection: () => void;
  isParticipantSelected: (participant: EventParticipantFragment) => boolean;
}

export const EventDetailsContext = createContext<
  EventDetailsContextType | undefined
>(undefined);
